import firebase from 'firebase/compat/app';
import STORE_CONSTANTS from '../constants';
import withoutNulls from '../../api/search/withoutNulls';
const CURRENT_LEGACY_SAVED_FILTER_VERSION = 'v1';
const LEGACY_SAVED_FILTER_DOC = 'legacySavedFilters';

const legacySavedFilterConverter = {
  toFirestore(savedFilter: LegacySavedFilter): firebase.firestore.DocumentData {
    return withoutNulls(savedFilter);
  },
  fromFirestore(
    snapshot: firebase.firestore.QueryDocumentSnapshot<LegacySavedFilter>,
    options: firebase.firestore.SnapshotOptions,
  ): LegacySavedFilter {
    const data = snapshot.data(options);
    return data;
  },
};

const getLegacySavedFiltersRef = ({
  accountId,
  db,
}: {
  accountId: string;
  db?: firebase.firestore.Firestore;
}) => {
  return (db ? db : firebase.firestore())
    .collection('accounts')
    .doc(accountId)
    .collection(STORE_CONSTANTS.FILTER_DEFINITIONS_COLLECTION)
    .doc(LEGACY_SAVED_FILTER_DOC)
    .collection(CURRENT_LEGACY_SAVED_FILTER_VERSION)
    .withConverter(legacySavedFilterConverter);
};

export default getLegacySavedFiltersRef;
